const DnDItemTypes = {
  QUESTION_TYPE: 'question_type',
  QUESTION: 'question',
}

export default DnDItemTypes
